"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import { caseStudies } from "src/utils/mock/caseStudies";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";

import { EmailAppHeroData, emailStatsData, emailSolutionsAndProcessData, emailPortfolioData, emailTechnologiesData, emailAboutData, emailFaqData } from "src/utils/mock/emailData";

export default function EmailAutomationComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const seoProjects = liveProjects.filter((project) => {
    const hasSeoTech = project.technologies?.some((tech) => tech.name?.toLowerCase() === "seo");
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasSeoTech && isActive;
  });

  const filteredData = {
    ...emailPortfolioData,
    projects: {
      liveProjects: seoProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={EmailAppHeroData} />
      <TechStats stats={emailStatsData} />

      <WhyChooseUs data={emailSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={emailTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Email Automation" sections={emailAboutData} />
        </div>
      </section>

      <FAQSection faqs={emailFaqData} />
      <CommonContactSection />
    </div>
  );
}
